import React from "react";
import PropTypes from "prop-types";
import ControlTemplate from "../BaseControls/ControlTemplate";
import {controlPropTypes} from "../formhelpers";
import BaseButton from "../BaseControls/Button";

export default class Button extends React.Component {
    render() {
        const {descriptor} = this.props;
        return (
            <ControlTemplate
                {...this.props}
                descriptor={{...descriptor, label: ""}}
                className=""
                extraProps={{
                    "data-widget-label": descriptor.label
                }}
            >
                <BaseButton
                    label={descriptor.label}
                    value={descriptor.label}
                    {...this.props}
                />
            </ControlTemplate>
        );
    }
}

Button.propTypes = {
    ...controlPropTypes(null, false),
    onCommitChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Widget/button.js